import React, { useRef, useEffect } from 'react';
import './Products.css';
import ImageCarousel from './imagecrousel';
import ProjectCarousel from './ProjectCrousel1'; // Import the new component
import ProjectCarousel2 from './projectcrousel2'; // Import the new component
import ProjectCarousel3 from './projectcrousel3'; // Import the new component
import ProjectCarousel4 from './projectcrousel4'; // Import the new component
import ProjectCarousel5 from './projectcrousel5'; // Import the new component
import ProjectCarousel6 from './projectcrousel6'; // Import the new component
import ProjectCarousel7 from './projectcrousel7'; // Import the new component

const Products = () => {
    const carouselRef = useRef(null);

    const scrollLeft = () => {
        if (carouselRef.current) {
            const { scrollWidth, clientWidth } = carouselRef.current;
            carouselRef.current.scrollBy({ left: -clientWidth, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (carouselRef.current) {
            const { scrollWidth, clientWidth } = carouselRef.current;
            carouselRef.current.scrollBy({ left: clientWidth, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (carouselRef.current) {
                const { scrollWidth, clientWidth, scrollLeft } = carouselRef.current;
                const maxScrollLeft = scrollWidth - clientWidth;
                const nextScrollLeft = scrollLeft + clientWidth;
                
                if (nextScrollLeft > maxScrollLeft) {
                    carouselRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    carouselRef.current.scrollBy({ left: clientWidth, behavior: 'smooth' });
                }
            }
        }, 3000); // Adjust interval as needed (3000 ms = 3 seconds)

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="products-page">
            {/* Banner Section */}
            <div className="products-banner">
                <button className="scroll-arrow left-arrow" onClick={scrollLeft}>←</button>
                <div className="banner-carousel" ref={carouselRef}>
                    <div className="carousel-container">
                        <div className="carousel-track">
                            <ImageCarousel />
                        </div>
                    </div>
                </div>
                <button className="scroll-arrow right-arrow" onClick={scrollRight}>→</button>
            </div>

  
{/* Project Details Section */}
<div className="projects-details">
                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup which has been setup successfully all over India.</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel />
                        </div>
                    </div>
                </section>

                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup of Delhi NCR.</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel2 />
                        </div>
                    </div>
                </section>

                <section className="project-section">
                    <h2>Our Campus Drives</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Company Head Mr Sanjeev Saini visits college campus to give young talent an oppurtunity.Jaikon belives in providing oppurtunity to new talent.</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel3 />
                        </div>
                    </div>
                </section>

                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup of Delhi NCR..</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel4 />
                        </div>
                    </div>
                </section>
                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup which has been setup successfully all over India.</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel5 />
                        </div>
                    </div>
                </section>
                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup which has been setup successfully all over India</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel6 />
                        </div>
                    </div>
                </section>
                <section className="project-section">
                    <h2>Our Clients Sites</h2>
                    <div className="project-content">
                        <div className="project-description">
                            <p>Our client cold stroage setup which has been setup successfully all over India</p>
                        </div>
                        <div className="project-images">
                            <ProjectCarousel7 />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    



           


    );
};

export default Products;
